import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { BaseControl, Container, Custom, DateTimePicker, Legend, Textbox, Usuario } from "@app/shared";
import { Usuarios } from "./inactive-users-data.services";

@Injectable()
export class InactivateUserFormService{
  constructor() { }

  /**
   * Configuración formulario para agregar o modificar una serie
   *
   * @param {SeriePredeterminada} [serie]
   * @returns {BaseControl<any>[]}
   * @memberof InactivateUserFormService
   */
  getFormUser(ngSelectTpl?: any, users?: any[], motivo?: any[]): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'funcionario',
        label: 'Funcionario a inactivar',
        order: 1,
        size: 'col-12 col-lg-6',
        template: ngSelectTpl,
        options: users,
        placeholder: 'Seleccione un funcionario',
        validations: {
          validators: [Validators.required]
        }
      }),
      
      new Custom({
        key: 'motivo',
        label: 'Motivo',
        order: 2,
        size: 'col-12 col-lg-6',
        template: ngSelectTpl,
        options: motivo,
        placeholder: 'Seleccione un motivo',
        validations: {
          validators: [Validators.required]
        },
      }),

      new DateTimePicker({
        order: 3,
        key: 'fecha_inicial',
        label: 'Fecha inicio:',
        pickerMode: 'dialog',
        pickerType: 'calendar',
        minDate: new Date(),
        class:{
          container: ['col-6 col-lg-6 pl-2']
        },
        placeholder: 'Seleccione fecha de inicio',
        validations: {
          validators: [Validators.required]
        }
      }),

      new DateTimePicker({
        order: 3,
        key: 'fecha_final',
        label: 'Fecha final:',
        pickerMode: 'dialog',
        pickerType: 'calendar',
        minDate: new Date(),
        class:{
          container: ['col-6 col-lg-6 pl-1']
        },
        placeholder: 'Seleccione fecha de finalizacion',
        validations: {
          validators: [Validators.required]
        }
      }),
      
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  getReason(objectModel?: any): BaseControl<any>[]{
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'motivo',
        type: 'text',
        label: 'Motivo:',
        size: 'col-12 col-lg-4',
        customMin: 0,
        placeholder: 'Ingrese el nuevo motivo',
        validations: {
          validators: [Validators.required],
        },
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
  
}


// WEBPACK FOOTER //
// ./src/app/administration/system-users-inactivation/inactivate-users/shared/inactive-user.form.services.ts